const ORDER_FORM_ROUTE = /(?:^|\/)(?:add-ord|my-sarvban\/buy-requests\/edit)(?:\/|$)/

export const isOrderFormRoute = (path = '') => ORDER_FORM_ROUTE.test(path)
